import { Theme, css } from '@emotion/react';
import React from 'react';

import { ACTION_DESKTOP_NAV_HEADER, CATEGORY_NAV } from 'utils/analytics/eventTypesConstants';
import { Button, IconButton } from 'omakase';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import { IconSearch } from '@tock/icons';
import { IconSearch as IconSearchLegacy } from 'ui/icons';

export interface TriggerProps {
  onClick(event: React.MouseEvent<HTMLButtonElement>): void;
}

export const OmakaseDesktopHeaderSearchTrigger: React.FC<TriggerProps> = ({ onClick }) => {
  const wrappedOnClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    onClick(event);
    window.analytics?.sendEvent(CATEGORY_NAV, ACTION_DESKTOP_NAV_HEADER, 'Search button engaged');
  };

  return (
    <>
      <Button
        css={({ breakpoints, spacing }: Theme) => css`
          display: none;
          ${breakpoints.up('md')} {
            display: flex;
            // for this ghost button, the hpad as derived in buttonCssDefs:buttonDimensionsFromSize is weirdly large, we trim it down
            padding: 0 ${spacing(3)}px;
          }
        `}
        iconStart={<IconMigrationUtil legacyIcon={<IconSearchLegacy />} newIcon={<IconSearch />} />}
        onClick={wrappedOnClick}
        size="large"
        variant="ghost"
        aria-haspopup
        data-testid="search-button"
      >
        Search
      </Button>
      <IconButton
        css={({ breakpoints, spacing }: Theme) => css`
          // for this ghost button, the hpad as derived in buttonCssDefs:buttonDimensionsFromSize is weirdly large, we trim it down
          padding: 0 ${spacing(3)}px;
          ${breakpoints.up('md')} {
            display: none;
          }
        `}
        aria-label="Search"
        onClick={wrappedOnClick}
        size="large"
        variant="ghost"
        aria-haspopup
        data-testid="search-button-icon-only"
      >
        <IconMigrationUtil legacyIcon={<IconSearchLegacy />} newIcon={<IconSearch />} />
      </IconButton>
    </>
  );
};
